import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu"]

  toggle(event) {
    event.preventDefault()
    this.open ? this.hide() : this.show()
  }

  show() {
    this.menuTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    if (this.nativeApp) document.body.classList.add("overflow-hidden")
    this.menuTarget.querySelector("[role=menuitem]")?.focus()
  }

  hide() {
    if (!this.open) return
    this.menuTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.comment?.classList.remove("review-comment--pressed")
    if (this.nativeApp) document.body.classList.remove("overflow-hidden")
    if (this.element.isConnected) this.triggerTarget.focus()
  }

  hideOnBackdrop(event) {
    if (event.target === this.menuTarget) this.hide()
  }

  hideOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  hideOnEscape(event) {
    if (event.key === "Escape") this.hide()
  }

  get open() {
    return !this.menuTarget.classList.contains("hidden")
  }

  get comment() {
    return this.element.closest(".review-comment")
  }

  get nativeApp() {
    return document.body.dataset.nativeApp === "true"
  }
}
